var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar card" }, [
    _c("ul", { staticClass: "nav" }, [
      _c("li", { staticClass: "nav-item mb-1" }, [
        _c(
          "a",
          {
            staticClass: "nav-link d-block px-2 py-1",
            class: { active: _vm.activeMenuItem === "profile" },
            attrs: { href: "/settings/profile" }
          },
          [_vm._v("Profile")]
        )
      ]),
      _vm._v(" "),
      _vm.$root.user.stripe_subscription
        ? _c("li", { staticClass: "nav-item mb-1" }, [
            _c(
              "a",
              {
                staticClass: "nav-link d-block px-2 py-1",
                class: { active: _vm.activeMenuItem === "contributions" },
                attrs: { href: "/settings/contributions" }
              },
              [_vm._v("Contributions")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("li", { staticClass: "nav-item mb-1" }, [
        _c(
          "a",
          {
            staticClass: "nav-link d-block px-2 py-1",
            class: { active: _vm.activeMenuItem === "advertisement" },
            attrs: { href: "/settings/advertisement" }
          },
          [_vm._v("Advertisement")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "nav-item" }, [
        _c(
          "a",
          {
            staticClass: "nav-link d-block px-2 py-1",
            class: { active: _vm.activeMenuItem === "billing" },
            attrs: { href: "/settings/billing" }
          },
          [_vm._v("Manage Subscription")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4bf870c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4bf870c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/SettingsSidebar.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b4bf870c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/SettingsSidebar.vue
// module chunks = 0 1